var _path, _path2, _path3, _path4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetricIoSaved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8021_9635)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8021_9635",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8021_9635)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z",
    fill: "url(#paint0_linear_8021_9635)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5423 6L17 8.75V14.25L12.5423 17L8.08464 14.25V12.875H9.37093L9.37095 13.4553L12.5423 15.4119L15.713 13.4553V9.54406L12.5423 7.58744L9.37095 9.54406L9.37093 10.125H8.08464V8.75L12.5423 6ZM11.719 8.95136L14.0797 11.5L11.719 14.0486L10.8184 13.0764L11.6414 12.1875H6.43825L7.26131 13.0764L6.36073 14.0486L4 11.5L6.36073 8.95136L7.26131 9.92364L6.43825 10.8125H11.6414L10.8184 9.92364L11.719 8.95136Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8021_9635",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 9,
    width: 3,
    height: 5
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 9H18V14H21V9Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8021_9635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3102 11.5C20.2053 11.3535 20.072 11.2758 19.9352 11.2813H19.0558C19.0157 11.283 18.9758 11.2712 18.9385 11.2466C18.9013 11.222 18.8673 11.1851 18.8388 11.1381C18.8103 11.0911 18.7877 11.035 18.7725 10.9732C18.7573 10.9113 18.7497 10.845 18.7502 10.7782C18.7492 10.7522 18.7492 10.7261 18.7502 10.7C18.762 10.5806 18.7996 10.4725 18.8559 10.3959C18.9121 10.3194 18.9832 10.2798 19.0558 10.2844H19.9221C19.9927 10.2843 20.0611 10.3261 20.115 10.4022C20.1689 10.4783 20.2049 10.5839 20.2164 10.7H20.4977C20.4859 10.4591 20.4202 10.2343 20.3135 10.0705C20.2069 9.90663 20.0671 9.81566 19.9221 9.81567H19.6258V9.09692H19.3914V9.81567H19.0558C18.9108 9.81566 18.771 9.90663 18.6644 10.0705C18.5577 10.2343 18.492 10.4591 18.4802 10.7C18.4793 10.7261 18.4793 10.7522 18.4802 10.7782C18.4802 10.9042 18.4951 11.0289 18.524 11.1453C18.5529 11.2617 18.5953 11.3675 18.6488 11.4566C18.7567 11.6365 18.9032 11.7375 19.0558 11.7375H19.9446C19.9843 11.7359 20.0239 11.7475 20.061 11.7717C20.098 11.7959 20.1318 11.8323 20.1602 11.8786C20.1887 11.9249 20.2114 11.9802 20.2268 12.0413C20.2423 12.1025 20.2502 12.1681 20.2502 12.2344C20.2521 12.2698 20.2521 12.3053 20.2502 12.3407C20.2353 12.4506 20.1984 12.5489 20.1456 12.6193C20.0928 12.6897 20.0272 12.7281 19.9596 12.7282H19.0783C19.0107 12.7281 18.9451 12.6897 18.8923 12.6193C18.8395 12.5489 18.8026 12.4506 18.7877 12.3407H18.5046C18.5207 12.5755 18.5881 12.7922 18.6939 12.9495C18.7997 13.1068 18.9365 13.1938 19.0783 13.1938H19.3914V13.9032H19.6258V13.1938H19.9446C20.0864 13.1938 20.2232 13.1068 20.329 12.9495C20.4348 12.7922 20.5022 12.5755 20.5183 12.3407V12.2344C20.5181 12.0941 20.4993 11.9555 20.4634 11.8286C20.4274 11.7017 20.3751 11.5895 20.3102 11.5Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8021_9635",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8021_9635"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricIoSaved);
export default __webpack_public_path__ + "static/media/Metric-IO-Saved.5e5df660f9971a5aab1d57eb16a3918c.svg";
export { ForwardRef as ReactComponent };